import React from 'react';

const Reload = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <mask
        id="mask0_1204_540"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1204_540)">
        <path
          d="M10 18.125C9.02778 18.125 8.11713 17.9403 7.26806 17.5708C6.41898 17.2014 5.68009 16.7023 5.0514 16.0736C4.42269 15.4449 3.92361 14.706 3.55417 13.8569C3.18472 13.0079 3 12.0972 3 11.125H4.5C4.5 12.6389 5.03819 13.934 6.11458 15.0104C7.19097 16.0868 8.48611 16.625 10 16.625C11.5139 16.625 12.809 16.0868 13.8854 15.0104C14.9618 13.934 15.5 12.6389 15.5 11.125C15.5 9.61111 14.9618 8.31597 13.8854 7.23958C12.809 6.16319 11.5112 5.625 9.99187 5.625H9.875L10.9375 6.6875L9.875 7.75L7 4.875L9.875 2L10.9375 3.0625L9.85417 4.125H10C10.9722 4.125 11.8829 4.30972 12.7319 4.67917C13.581 5.04861 14.3199 5.54769 14.9486 6.1764C15.5773 6.80509 16.0764 7.54398 16.4458 8.39306C16.8153 9.24213 17 10.1528 17 11.125C17 12.0972 16.8153 13.0079 16.4458 13.8569C16.0764 14.706 15.5773 15.4449 14.9486 16.0736C14.3199 16.7023 13.581 17.2014 12.7319 17.5708C11.8829 17.9403 10.9722 18.125 10 18.125Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default Reload;
